var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2770.351,
    height: 2097.145,
    viewBox: "0 0 2770.351 2097.145"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Silvy_-_Icon_-_White",
    "data-name": "Silvy - Icon - White",
    d: "M784.141,2476.3c-478.618,33.017-763.169-323.713-782.6-684.212-28.027-519.9,334.356-662.059,489.395-919.6C747.82,445.73,333.552,301.1,359.423,124.5S672.033-15.282,870.379,77.907c268.716,126.251,682.869,708.855,77.612,1052.067-531.907,301.611-631.569,527.587-674.2,662.109-66.834,210.9,14.987,535.635,375.667,535.635,255.412,0,324.4-229.059,264.036-398.273-45.5-127.552-102.46-326.633-8.624-458.62,81.926-115.234,209.122-181.2,357.882-159.377,187.565,27.522,267.365,160.706,301.834,291.832C1665.131,1985.82,1262.755,2443.278,784.141,2476.3Z",
    transform: "matrix(-0.225, -0.974, 0.974, -0.225, 355.449, 2097.145)",
    fill: "rgba(250,237,228,0.5)"
  })));
};

export default __webpack_public_path__ + "static/media/silvy_s_header_2.aa880aaa.svg";
export { SvgComponent as ReactComponent };